var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-indicator",class:_vm.status},[_c('font-awesome-icon',{staticClass:"indicator",attrs:{"icon":['fal', _vm.statusIcon]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }